import { css, Interpolation, Theme } from '@emotion/react'

export const container = (theme: Theme) => css`
  width: 100%;
  max-width: 1190px;
  margin: 0 auto;
  min-height: 100%;
  padding: ${theme.spacing(3)};
`

export const header = (theme: Theme) => css`
  display: block;
  margin: ${theme.spacing(2)} 0;

  font-weight: 700;
`

export const tabs = (theme: Theme) => css`
  margin: ${theme.spacing(4, 0, 3)};
`

export const link: Interpolation<Theme> = (theme: Theme) => css`
  color: ${theme.colors.blueHover};
`

export const tablesWrapper: Interpolation<Theme> = css`
  margin-top: 24px;
`

export const table: Interpolation<Theme> = css`
  .table-header .table-cell {
    font-weight: 700;
  }

  .table-row {
    padding: 5px 12px;
  }
`
